import { render, staticRenderFns } from "./tap6.vue?vue&type=template&id=2f101a6b&scoped=true&"
import script from "./tap6.vue?vue&type=script&lang=js&"
export * from "./tap6.vue?vue&type=script&lang=js&"
import style0 from "./tap6.vue?vue&type=style&index=0&id=2f101a6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f101a6b",
  null
  
)

export default component.exports